import React from "react";
import { Form } from "react-bootstrap";
import Icon from "@mdi/react";
import {
  mdiChevronDown,
  mdiChevronUp,
  mdiCloseCircle,
  mdiInformationOutline,
} from "@mdi/js";
import EditPhotoArea from "./editPhotoArea";
import { CONCERN_LEVEL_OPTIONS } from "./editItemFormConstants";

// S4 "Modify Observation" body — controlled by the parent (editItemForm).
const EditItemFormS4 = ({
  item,
  isIssue,
  isOverview,
  observationsTitle,
  photoAreaProps,
  noteValue,
  onNoteChange,
  s4ConcernLevel,
  onConcernLevelChange,
  s4ValidationError,
  currentResultExpanded,
  setCurrentResultExpanded,
}) => (
  <>
    <div className="edit-form-s4-header">
      <h2 className="edit-form-s4-title">{observationsTitle}</h2>
    </div>
    <div className="edit-form-s4-body">
      <div className="edit-form-observations-hint">
        <Icon path={mdiInformationOutline} size={0.667} />
        <span>Add short note or annotation for more precise analysis.</span>
      </div>

      <EditPhotoArea {...photoAreaProps} />

      <div className="edit-form-s4-row">
        <label className="edit-form-s4-row-label">Note</label>
        <Form.Control
          type="text"
          className="edit-form-s4-row-input"
          value={noteValue}
          onChange={onNoteChange}
          placeholder="Add a note (optional)"
        />
      </div>

      {isIssue && (
        <div className="edit-form-s4-row">
          <label className="edit-form-s4-row-label">
            Concerning Level{" "}
            <span className="edit-form-s4-required">*</span>
          </label>
          <div className="edit-form-s4-concern-options">
            {CONCERN_LEVEL_OPTIONS.map(({ value, label, iconSrc }) => (
              <label
                key={value}
                className="edit-form-s4-concern-option"
                htmlFor={`s4-concern-${item.id}-${value}`}
              >
                <input
                  type="radio"
                  id={`s4-concern-${item.id}-${value}`}
                  name={`s4-concern-${item.id}`}
                  checked={s4ConcernLevel === value}
                  onChange={() => onConcernLevelChange(value)}
                  className="edit-form-s4-concern-radio"
                />
                <span className="edit-form-s4-concern-label">{label}</span>
                <img
                  src={iconSrc}
                  alt=""
                  className="edit-form-s4-concern-icon"
                />
              </label>
            ))}
          </div>
        </div>
      )}

      {s4ValidationError && (
        <div className="edit-form-s4-validation-error">
          <Icon path={mdiCloseCircle} size={0.667} /> {s4ValidationError}
        </div>
      )}

      <hr className="edit-form-divider" />

      <div className="edit-form-s4-current-result">
        <button
          type="button"
          className="edit-form-s4-current-result-toggle"
          onClick={() => setCurrentResultExpanded((v) => !v)}
        >
          <Icon
            path={currentResultExpanded ? mdiChevronUp : mdiChevronDown}
            size={0.75}
          />
          <span>Current Result</span>
        </button>
        {currentResultExpanded && (
          <div className="edit-form-s4-current-result-body">
            {isOverview ? (
              item.description && (
                <p className="edit-form-s4-current-text">{item.description}</p>
              )
            ) : (
              <>
                {item.name && (
                  <h4 className="edit-form-s4-current-name">{item.name}</h4>
                )}
                {item.description && (
                  <div className="edit-form-s4-current-row">
                    <span className="edit-form-s4-current-label">
                      Description
                    </span>
                    <span className="edit-form-s4-current-value">
                      {item.description}
                    </span>
                  </div>
                )}
                {isIssue && item.cause && (
                  <div className="edit-form-s4-current-row">
                    <span className="edit-form-s4-current-label">Cause</span>
                    <span className="edit-form-s4-current-value">
                      {item.cause}
                    </span>
                  </div>
                )}
                {isIssue && item.solution && (
                  <div className="edit-form-s4-current-row">
                    <span className="edit-form-s4-current-label">Solution</span>
                    <span className="edit-form-s4-current-value">
                      {item.solution}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  </>
);

export default EditItemFormS4;
